import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — Golden Wolf Foundation` : "Golden Wolf Foundation";
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = description;
    }
  }, [title, description]);
}
